import {ReactComponent as CloseIcon} from './close.svg'

function Close() {
  return <CloseIcon />
}

export default Close
